import "../pages.scss"
import { RolesState } from '../../context/roles/RolesState';
import Datatable from "./rolesTable/Datatable"

const RolesPage = () => {
  return (
    <>
      <RolesState>
        <Datatable />
      </RolesState>

    </>
  )
}

export default RolesPage